module.exports = __webpack_public_path__ + "assets/clipboard.a754c187.svg";